module.exports = "/static/assets/de9ae687b647bf9a137a3f447bacbce1.svg";